export default {"src":"/_next/static/media/favicon.33e3c67f.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};